var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTronogLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 70C10 36.8643 36.8643 10 70 10C103.136 10 130 36.8643 130 70C130 103.136 103.136 130 70 130C36.8643 130 10 103.136 10 70ZM17.4512 70C17.4512 99.0213 40.9787 122.549 70 122.549C99.0213 122.549 122.549 99.0213 122.549 70C122.549 40.9787 99.0213 17.4512 70 17.4512C40.9787 17.4512 17.4512 40.9787 17.4512 70ZM61.3064 57.6657L92.875 57.7401V64.4257H77.1592C75.5474 64.4257 74.2425 65.7276 74.2365 67.3394L74.1978 89.1121H66.687L66.7466 67.1994C66.7526 65.668 65.5161 64.4227 63.9848 64.4197H63.4902H63.2668C62.1406 64.4257 60.8893 64.5895 59.93 65.1794L45.2659 73.9981V65.8528L57.1384 58.9259C58.4195 58.187 59.5129 57.6657 61.3064 57.6657Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTronogLogo);
export default __webpack_public_path__ + "static/media/tronog-logo.4f98414282e7b3830cadbb7a96746462.svg";
export { ForwardRef as ReactComponent };